import { initialTableShow } from 'utils/settings';

export const mainTableConf = [
  {
    isSortable: true,
    field: 'sentimentDate',
    title: 'Sentiment Date',
    show: true,
    width: 172,
    valuesExport: ['sentimentDate']
  },
  {
    isSortable: true,
    field: 'sentiment',
    title: 'Sentiment',
    show: true,
    width: 382,
    valuesExport: ['sentiment']
  },
  {
    isSortable: false,
    field: 'comments',
    title: 'Comments',
    show: true,
    width: 382,
    valuesExport: ['comments']
  }
];

export const exportConfigSentiment = {
  exportUrl: '/customer/satisfaction/sentiment/export',
  exportName: 'sentiment',
  exportFormat: 'zip'
};

export const defaultFilters = {
  search: '',
  sentimentDate: { startDate: null, endDate: null },
  sentiment: []
};

export const defaultNavigation = {
  fieldName: 'sentimentDate',
  direction: initialTableShow.direction,
  currentPage: initialTableShow.currentPage,
  itemsPerPage: initialTableShow.itemsPerPage
};
